import React from "react";
import { Typography, Paper, Grid, Box, Card, CardContent, List, ListItem, ListItemText, Button, Divider } from "@material-ui/core";
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';
import { withRouter } from "react-router";
import Cookies from "js-cookie";
import { RadarChart, Radar, PolarGrid, PolarAngleAxis, Tooltip, PolarRadiusAxis, Legend } from "recharts";
import kibun from "./data/kibun.json";

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);

let card_style = {
  height: "100%",
  backgroundColor: "#fff"
}



/**
 * 結果表示
 */
class Result2 extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      result: JSON.parse(Cookies.get("k-mental-second") || "{}"),
    }
    console.log(Cookies.get("k-mental-second"));
  }


  /**
   * Card表示
   * @param {*} type
   * @param {*} title
   * @param {*} text
   */
  renderCard(type, title, text) {
    return (
      <Grid item xs={11} sm={4} md={3} lg={3} >
        <Card style={card_style}>
          <CardContent>
            <Typography variant="h6">[{type}]{title}</Typography>
            <Typography variant="body2">{text}</Typography>
          </CardContent>
        </Card>
      </Grid>
    )
  }

  generate_list() {
    const tmp = [
      {
        "text": "厚生労働省 心のケア セルフケア探偵",
        "url": "https://kokoro.mhlw.go.jp/ps/detective/",
        "addon": ""
      },
      {
        "text": "厚生労働省 心のケア 東京ストレッチ物語",
        "url": "https://kokoro.mhlw.go.jp/ps/tokyo_stretch.html",
        "addon": ""
      },
      {
        "text": "東京大学大学院医学系研究科精神保健学分野　いまここケア",
        "url": "https://imacococare.net/",
        "addon": ""
      },
      {
        "text": "近畿大学メディカルサポートセンター",
        "url": "https://www.kindai.ac.jp/health/diagnosis/",
        "addon": "内科診察/心療内科/カウンセリングはこちら"
      }
    ]
    return tmp.map(i => {
      if (i.addon !== "") {
        return <ListItem button component="a" href={i.url}>
          <ListItemText primary={i.text} secondary={i.addon}></ListItemText>
        </ListItem>
      }
      return <ListItem button component="a" href={i.url}>
        <ListItemText primary={i.text} secondary={i.url}></ListItemText>
      </ListItem>
    })
  }


  renderRadar(d) {
    return (
      <Grid container alignItems="center" justify="center">
        <Grid item>
          <RadarChart
            outerRadius={100}
            width={300}
            height={300}
            data={d}
          >
            <PolarGrid></PolarGrid>
            <PolarAngleAxis dataKey="rank"></PolarAngleAxis>
            <PolarRadiusAxis />
            {
              // 自分の色を濃くし，平均の色を薄くする
            }
            <Radar
              name="大学生の平均"
              dataKey="average"
              fill="#3399ff"
              fillOpacity={0.3}
            ></Radar>
            <Radar
              name="あなたの点数"
              dataKey="value"
              stroke="#33cc33"
              fill="#33cc33"
              fillOpacity={0.5}
            ></Radar>
            <Tooltip></Tooltip>
            <Legend />
          </RadarChart>
        </Grid>
      </Grid>
    )
  }

  renderSupport() {
    const tmp = []
    for (var k of Object.keys(kibun)) {
      tmp.push(<Box p={1}>
        <Typography variaht="h5">{kibun[k].title}が高い人へ</Typography>
        <Typography variant="body2">{kibun[k].text}</Typography>
      </Box>);
    }
    console.log(tmp);
    return tmp;
  }


  render() {
    const d = this.state.result;
    console.log(d);
    return (
      <ThemeProvider theme={theme}>
        <Grid container alignItems="center" justify="center">
          <Grid item xs={11}>
            <Box p={1}>
              <Paper>
                <Box p={2}>
                  <Typography variant="h4">
                    気持ちのチェックリスト 結果
                  </Typography>
                  {this.renderRadar(d)}
                  <Typography variant="caption">
                    引用文献: 坂野雄二・福井和美・熊野宏昭ほか（1994）：新しい気分調査票の開発とその信頼性・妥当性の検討　心身医学. 34. 629-639.
                  </Typography>
                </Box>

                <Box p={2}>
                  {this.renderSupport()}
                </Box>
              </Paper>
            </Box>
          </Grid>
          <Grid item>

          </Grid>
          <Grid item xs={11}>
            <Box p={1}>
              <Paper>
                <Box p={2}>
                  <Typography variant="h4">
                    心のケア情報はこちら😀
                  </Typography>
                  <List>
                    {this.generate_list()}
                  </List>
                </Box>
              </Paper>
            </Box>

          </Grid>
          <Grid item xs={11}>
            <Box p={1}>
              <Paper>
                <Box p={2}>
                  <Grid container justify="center" spacing={1}>
                    <Grid item>
                      <Button variant="contained" size="large" color="primary" onClick={() => {
                        this.props.history.push("/Result")
                      }}>ストレスチェックの結果(オススメコンテンツ紹介)へ戻る</Button>
                    </Grid>
                    <Grid item>
                      <Button variant="contained" size="large" color="primary" href="https://docs.google.com/forms/d/e/1FAIpQLSe6b5ND0i88MxgkOedbgf0gKrMkYy14VAOxHZgHArd0QBoBRQ/viewform?usp=sf_link">終了して事後アンケートへ</Button>
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Box>

          </Grid>

        </Grid>
      </ThemeProvider>

    );
  }
}

export default withRouter(Result2);
